import React from "react";
import { BusinessCard } from "./UI/BusinessCard";
import { LoginCard } from "./UI/LoginCard";

export class LoginView extends React.Component {
  render() {
    const {
      loading,
      rememberMe,
      showPassword,
      showBusinesses,
      businessOptions,
      selectedBusiness,
      email,
      password,
      handleSubmitFirebase,
      handleSubmitLogin,
      handleKeyPress,
      onInputChange,
      onDropChange,
      onCheckboxChange,
      toggleShowPassword
    } = this.props;

    return (
      <React.Fragment>
        {showBusinesses ? (
          <BusinessCard
            loading={loading}
            businessOptions={businessOptions}
            selectedBusiness={selectedBusiness}
            handleSubmitLogin={handleSubmitLogin}
            onDropChange={onDropChange}
          />
        ) : (
          <LoginCard
            loading={loading}
            rememberMe={rememberMe}
            showPassword={showPassword}
            email={email}
            password={password}
            handleSubmitFirebase={handleSubmitFirebase}
            handleKeyPress={handleKeyPress}
            onInputChange={onInputChange}
            onCheckboxChange={onCheckboxChange}
            toggleShowPassword={toggleShowPassword}
          />
        )}
        <label
          style={{
            color: "white",
            position: "absolute",
            right: "6px",
            bottom: "6px",
            zIndex: "1"
          }}
        >
          © 2020 BPMBuild Limited (UK). All rights reserved.
        </label>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginView.js